<template>
  <div class="status-table">
    <v-row 
      class="control-bar"
      align="center"
    >
      
      <v-col cols="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-chip-group v-model="selectedFilter" multiple active-class="third--text" class="ma-4">
          <v-chip v-for="tag in filters" :key="tag.val">{{ tag.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th 
              v-for="(item, index) in headers" 
              :key="index"
              class="text-left"
            >
              {{item.text}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in filteredItems"
            :key="index"
          >
            <td v-if="isAssigned">{{ item.vehicle_name }}</td>
            <td v-if="!isAssigned">{{ item.install_tag }}</td>
            <td v-if="!isAssigned">{{ item.imei }}</td>
            <td>
              <span :class="item.status_name">{{ statusMap(item.status_name) }}</span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-btn 
          text
          @click="toggleConfig"
        >
          View Config
        </v-btn>
      </v-col>
    </v-row>

    <ReviewJobConfigChange 
      :display="displayConfig"
      :config="config"
      @close="toggleConfig"
    />
  </div>
</template>

<script>

import ReviewJobConfigChange from '@/components/deviceConfig/components/ReviewJobConfigChange.vue'

import { Logger } from "aws-amplify"
const logger = new Logger("Status Table")

export default {
  name: 'ConfigStatusTable',
  components: {
    ReviewJobConfigChange
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    config: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      headers: [],
      search: '',
      selectedFilter: [],
      displayConfig: false
    }
  },
  computed: {
    filters() {
      return [
        { text: 'Done', val: 'done'},
        { text: 'Error', val: 'error'},
        { text: 'Pending', val: 'pending'}
      ]
    },
    filteredItems() {
      let results = this.items;
      let filters = this.selectedFilter.map(i => this.filters[i].val);

      if(this.search.length > 0) {
        results = this.items.filter(item => {
          return item.imei.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || item.install_tag.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        });
      }

      if (this.selectedFilter.length > 0) {
        results = this.items.filter(i => filters.includes(i.state.status));
      }

      return results
    },
    isAssigned() {
      let assignedItems = this.items.filter(item => {
        return item.vehicle_name != '';
      });

      return assignedItems.length > 0 ? true : false;
    }
  },
  mounted() {
    this.setHeaders();
  },
  methods: {
    setHeaders() {
      let headers = [];

      if(this.isAssigned) {
        logger.info('is assigned')
        headers = [
          {
            text: 'Vehicle Name',
            value: 'vehicle_name'
          },
          { 
            text: "Status", 
            value: "" 
          },
        ]
      }
      else if (!this.isAssigned) {
        logger.info('is not assigned')
        headers = [
          { 
            text: "Install Tag", 
            value: "install_tag" 
          },
          { 
            text: "IMEI", 
            value: "imei" 
          },
          { 
            text: "Status", 
            value: "" 
          },
        ]
      }

      this.headers = headers;
    },
    toggleConfig() {
      this.displayConfig = !this.displayConfig
    },
    statusMap(status) {
      logger.info('status map ', status)
      let statusMap = {
        pending: 'Pending',
        error: 'Error',
        done: 'Done',
        success: 'Success',
        unknown: 'Unknown',
        cancelled: 'Cancelled'
      }

      return statusMap[status];
    }
  }
}
</script>

<style lang="scss" scoped>
  .status-table {
    padding: 1em;
    border: thin solid rgba(0, 0, 0, 0.12);

    .control-bar {
      padding-left: 1em;
    }

    .pending {
      color: #ff9800;
    }

    .error {
      color: red;
      background-color: initial !important;
    }

    .cancelled {
      color: red;
      background-color: initial !important;
    }

    .done {
      color: #5cb860;
    }

    .unknown {
      color: grey;
    }

    .success {
      color: #5cb860;
    }
  }


</style>